export default "__VITE_ASSET__BH8h_psJ__"